// extracted by mini-css-extract-plugin
export default {"large":"only screen and (min-width: 992px)","link":"_1T9Lo cXdS1 hRgdS"};